/** Dial geometry in the face's viewBox. */
export const DIAL = {
  width: 232,
  height: 240,
  cx: 114,
  cy: 120,
  r: 86,
  band: { x: 46, y: 180, width: 136, height: 44 },
} as const;

/**
 * The remaining share as a Time Timer wedge: its edge sits where a clock
 * hand would after the elapsed share, and the red runs clockwise from there
 * back to 12, so the edge advances clockwise as time passes. Empty at zero;
 * a full disc at one.
 */
export function wedgePath(cx: number, cy: number, r: number, frac: number) {
  if (frac <= 0) return "";
  if (frac >= 0.9999)
    return `M${cx} ${cy - r}A${r} ${r} 0 1 1 ${cx - 0.01} ${cy - r}Z`;
  const a = (1 - frac) * 2 * Math.PI;
  const x = +(cx + r * Math.sin(a)).toFixed(2);
  const y = +(cy - r * Math.cos(a)).toFixed(2);
  return `M${cx} ${cy}L${x} ${y}A${r} ${r} 0 ${frac > 0.5 ? 1 : 0} 1 ${cx} ${cy - r}Z`;
}
